import axiosInstance from './api';

/**
 * Upload a chat attachment via the API (server → S3).
 * Profile/prompt uploads use the same pattern; presigned browser PUT requires
 * extra S3 bucket CORS rules and often fails from localhost.
 */
export async function uploadMessagingAttachment(
  file: File,
  purpose: 'chat_image' | 'chat_audio' | 'chat_file' = 'chat_file'
): Promise<{ publicUrl: string; attachmentType: string }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('purpose', purpose);

  const { data } = await axiosInstance.post('messageshub/attachments/upload', formData);

  const payload = data.success !== undefined ? data : { success: true, ...data };
  if (!payload.success || !payload.public_url) {
    throw new Error(payload.message || 'Upload failed');
  }

  let attachmentType = payload.attachment_type || 'file';
  if (!payload.attachment_type) {
    if (file.type.startsWith('image/')) attachmentType = 'image';
    else if (file.type.startsWith('video/')) attachmentType = 'video';
    else if (file.type.startsWith('audio/')) attachmentType = 'audio';
  }

  return { publicUrl: payload.public_url, attachmentType };
}

/** @deprecated Use uploadMessagingAttachment — presign PUT needs S3 CORS. */
export const presignMessagingUpload = uploadMessagingAttachment;
